import { Navigate } from "react-router";
import { getLandingPage } from "../utils/pathnameUtils";

export default function LandingPageContainer() {
  return <Navigate to={getLandingPage()} replace />;
}
